import React from "react";
import {
  PageWrapper,
  HeroWrapper,
  ChartsRow,
  TransactionsRow,
  RecurringRow,
  SectionCard,
  SectionHeader,
  TitleBlock,
} from "../../styles";
import {
  HeroCardSkeleton,
  HeroGridSkeleton,
  HeroLeftSkeleton,
  StatsPanelSkeleton,
  StatRowSkeleton,
  ChartAreaSkeleton,
  RowsSkeleton,
  TransactionRowSkeleton,
  RecurringGridSkeleton,
  RecurringCardSkeleton,
  SkeletonBox,
} from "./styles";

const STAT_ROWS = [0, 1, 2];
const CHART_CARDS = [0, 1];
const TRANSACTION_ROWS = [0, 1, 2, 3, 4];
const RECURRING_CARDS = [0, 1, 2];

export const AccountDetailsSkeleton: React.FC = () => {
  return (
    <PageWrapper aria-label="Loading account details" aria-live="polite">
      <HeroWrapper>
        <HeroCardSkeleton>
          <HeroGridSkeleton>
            <HeroLeftSkeleton>
              <SkeletonBox width="55%" height="36px" />
              <SkeletonBox width="40%" height="16px" />
              <SkeletonBox width="50%" height="64px" />
              <SkeletonBox width="45%" height="28px" />
            </HeroLeftSkeleton>
            <StatsPanelSkeleton>
              {STAT_ROWS.map((row) => (
                <StatRowSkeleton key={row}>
                  <SkeletonBox width="40%" height="16px" />
                  <SkeletonBox width="25%" height="20px" />
                </StatRowSkeleton>
              ))}
            </StatsPanelSkeleton>
          </HeroGridSkeleton>
        </HeroCardSkeleton>
      </HeroWrapper>

      <ChartsRow>
        {CHART_CARDS.map((card) => (
          <SectionCard key={card}>
            <SectionHeader>
              <TitleBlock>
                <SkeletonBox width="160px" height="20px" />
                <SkeletonBox width="120px" height="14px" />
              </TitleBlock>
              <SkeletonBox width="90px" height="32px" />
            </SectionHeader>
            <ChartAreaSkeleton />
          </SectionCard>
        ))}
      </ChartsRow>

      <TransactionsRow>
        <SectionCard>
          <SectionHeader>
            <TitleBlock>
              <SkeletonBox width="180px" height="20px" />
              <SkeletonBox width="100px" height="14px" />
            </TitleBlock>
            <SkeletonBox width="140px" height="36px" />
          </SectionHeader>
          <RowsSkeleton>
            {TRANSACTION_ROWS.map((row) => (
              <TransactionRowSkeleton key={row}>
                <SkeletonBox width="64px" height="24px" />
                <SkeletonBox width="100%" height="16px" />
                <SkeletonBox width="80px" height="16px" />
              </TransactionRowSkeleton>
            ))}
          </RowsSkeleton>
        </SectionCard>
      </TransactionsRow>

      <RecurringRow>
        <SectionCard>
          <SectionHeader>
            <TitleBlock>
              <SkeletonBox width="200px" height="20px" />
              <SkeletonBox width="160px" height="14px" />
            </TitleBlock>
            <SkeletonBox width="80px" height="20px" />
          </SectionHeader>
          <RecurringGridSkeleton>
            {RECURRING_CARDS.map((card) => (
              <RecurringCardSkeleton key={card} />
            ))}
          </RecurringGridSkeleton>
        </SectionCard>
      </RecurringRow>
    </PageWrapper>
  );
};
